import { BlockedTenantRecordDTO } from '@reposit/api-client';
import { BlockTenantPayload, FetchOrganizationUsersByUserIdPayload, UnblockTenantPayload, UpdateUserPayload } from './user.types';

export const FETCH_ORGANIZATION_USERS_STORE_KEY = 'USER/FETCH_ORGANIZATION_USERS';
export const FETCH_ORGANIZATION_USERS_API_REQUESTED = `USER/FETCH_ORGANIZATION_USERS_API_REQUESTED`;
export const FETCH_ORGANIZATION_USERS_API_SUCCESS = 'USER/FETCH_ORGANIZATION_USERS_API_SUCCESS';
export const FETCH_ORGANIZATION_USERS_API_FAILED = 'USER/FETCH_ORGANIZATION_USERS_API_FAILED';

export const FETCH_USER_BY_ID_STORE_KEY = 'USER/FETCH_USER_BY_ID';
export const FETCH_USER_BY_ID_API_REQUESTED = 'USER/FETCH_USER_BY_ID_API_REQUESTED';
export const FETCH_USER_BY_ID_API_SUCCESS = 'USER/FETCH_USER_BY_ID_API_SUCCESS';
export const FETCH_USER_BY_ID_API_FAILED = 'USER/FETCH_USER_BY_ID_API_FAILED';

export const RESET_USER_PASSWORD_STORE_KEY = 'USER/RESET_USER_PASSWORD';
export const RESET_USER_PASSWORD_API_REQUESTED = 'USER/RESET_USER_PASSWORD_API_REQUESTED';
export const RESET_USER_PASSWORD_API_SUCCESS = 'USER/RESET_USER_PASSWORD_API_SUCCESS';
export const RESET_USER_PASSWORD_API_FAILED = 'USER/RESET_USER_PASSWORD_API_FAILED';

export const FETCH_ORGANIZATION_USER_BY_USER_ID_STORE_KEY = 'USER/FETCH_ORGANIZATION_USER_BY_USER_ID';
export const FETCH_ORGANIZATION_USER_BY_USER_ID_API_REQUESTED = 'USER/FETCH_ORGANIZATION_USER_BY_USER_ID_API_REQUESTED';
export const FETCH_ORGANIZATION_USER_BY_USER_ID_API_SUCCESS = 'USER/FETCH_ORGANIZATION_USER_BY_USER_ID_API_SUCCESS';
export const FETCH_ORGANIZATION_USER_BY_USER_ID_API_FAILED = 'USER/FETCH_ORGANIZATION_USER_BY_USER_ID_API_FAILED';

export const UPDATE_USER_BY_ID_STORE_KEY = 'USER/UPDATE_USER_BY_ID';
export const UPDATE_USER_BY_ID_API_REQUESTED = 'USER/UPDATE_USER_BY_ID_API_REQUESTED';
export const UPDATE_USER_BY_ID_API_SUCCESS = 'USER/UPDATE_USER_BY_ID_API_SUCCESS';
export const UPDATE_USER_BY_ID_API_FAILED = 'USER/UPDATE_USER_BY_ID_API_FAILED';

export const SET_IS_EDIT_MODAL_OPEN = 'USER/SET_IS_EDIT_MODAL_OPEN';

export const BLOCK_TENANT_STORE_KEY = 'USER/BLOCK_TENANT';
export const BLOCK_TENANT_API_REQUESTED = 'USER/BLOCK_TENANT_API_REQUESTED';
export const BLOCK_TENANT_API_SUCCESS = 'USER/BLOCK_TENANT_API_SUCCESS';
export const BLOCK_TENANT_API_FAILED = 'USER/BLOCK_TENANT_API_FAILED';

export const FETCH_BLOCKED_TENANT_STORE_KEY = 'USER/FETCH_BLOCKED_TENANT';
export const FETCH_BLOCKED_TENANT_API_REQUESTED = 'USER/FETCH_BLOCKED_TENANT_API_REQUESTED';
export const FETCH_BLOCKED_TENANT_API_SUCCESS = 'USER/FETCH_BLOCKED_TENANT_API_SUCCESS';
export const FETCH_BLOCKED_TENANT_API_FAILED = 'USER/FETCH_BLOCKED_TENANT_API_FAILED';

export const UNBLOCK_TENANT_STORE_KEY = 'USER/UNBLOCK_TENANT';
export const UNBLOCK_TENANT_API_REQUESTED = 'USER/UNBLOCK_TENANT_API_REQUESTED';
export const UNBLOCK_TENANT_API_SUCCESS = 'USER/UNBLOCK_TENANT_API_SUCCESS';
export const UNBLOCK_TENANT_API_FAILED = 'USER/UNBLOCK_TENANT_API_FAILED';

export function fetchOrganizationUsersRequested(organizationId?: string) {
  return {
    type: FETCH_ORGANIZATION_USERS_API_REQUESTED,
    payload: {
      organizationId,
    },
  } as const;
}

export function fetchOrganizationUsersSuccess(payload: string[]) {
  return {
    type: FETCH_ORGANIZATION_USERS_API_SUCCESS,
    payload,
  } as const;
}

export function fetchOrganizationUsersFailed(error: string) {
  return {
    type: FETCH_ORGANIZATION_USERS_API_FAILED,
    payload: error,
  } as const;
}

export function fetchUserByIdRequested(userId: string) {
  return {
    type: FETCH_USER_BY_ID_API_REQUESTED,
    payload: { userId },
  } as const;
}

export function fetchUserByIdSuccess() {
  return {
    type: FETCH_USER_BY_ID_API_SUCCESS,
  } as const;
}

export function fetchUserByIdFailed(error: string) {
  return {
    type: FETCH_USER_BY_ID_API_FAILED,
    payload: error,
  } as const;
}

export function resetUserPasswordRequested(userId: string, email: string) {
  return {
    type: RESET_USER_PASSWORD_API_REQUESTED,
    payload: { userId, email },
  } as const;
}

export function resetUserPasswordSuccess() {
  return {
    type: RESET_USER_PASSWORD_API_SUCCESS,
  } as const;
}

export function resetUserPasswordFailed(error: string) {
  return {
    type: FETCH_USER_BY_ID_API_FAILED,
    payload: error,
  } as const;
}

export function fetchOrganizationUsersByUserIdRequested(payload: FetchOrganizationUsersByUserIdPayload) {
  return {
    type: FETCH_ORGANIZATION_USER_BY_USER_ID_API_REQUESTED,
    payload,
  } as const;
}

export function fetchOrganizationUsersByUserIdSuccess() {
  return {
    type: FETCH_ORGANIZATION_USER_BY_USER_ID_API_SUCCESS,
  } as const;
}

export function fetchOrganizationUsersByUserIdFailed(error: string) {
  return {
    type: FETCH_ORGANIZATION_USER_BY_USER_ID_API_FAILED,
    payload: error,
  } as const;
}

export function updateUserByIdRequested(payload: UpdateUserPayload) {
  return {
    type: UPDATE_USER_BY_ID_API_REQUESTED,
    payload,
  } as const;
}

export function updateUserByIdSuccess() {
  return {
    type: UPDATE_USER_BY_ID_API_SUCCESS,
  } as const;
}

export function updateUserByIdFailed(error: string) {
  return {
    type: UPDATE_USER_BY_ID_API_FAILED,
    payload: error,
  } as const;
}

export function setIsEditModalOpen(payload: boolean) {
  return {
    type: SET_IS_EDIT_MODAL_OPEN,
    payload,
  } as const;
}

export function blockTenantRequested(payload: BlockTenantPayload) {
  return {
    type: BLOCK_TENANT_API_REQUESTED,
    payload,
  } as const;
}

export function blockTenantSuccess(payload: BlockedTenantRecordDTO) {
  return {
    type: BLOCK_TENANT_API_SUCCESS,
    payload,
  } as const;
}

export function blockTenantFailed(error: string) {
  return {
    type: BLOCK_TENANT_API_FAILED,
    payload: error,
  } as const;
}

export function fetchBlockedTenantRequested(email: string) {
  return {
    type: FETCH_BLOCKED_TENANT_API_REQUESTED,
    payload: { email },
  } as const;
}

export function fetchBlockedTenantSuccess(payload: BlockedTenantRecordDTO | null, email: string) {
  return {
    type: FETCH_BLOCKED_TENANT_API_SUCCESS,
    payload,
    meta: { email },
  } as const;
}

export function fetchBlockedTenantFailed(error: string, email: string) {
  return {
    type: FETCH_BLOCKED_TENANT_API_FAILED,
    payload: error,
    meta: { email },
  } as const;
}

export function unblockTenantRequested(payload: UnblockTenantPayload) {
  return {
    type: UNBLOCK_TENANT_API_REQUESTED,
    payload,
  } as const;
}

export function unblockTenantSuccess(email: string) {
  return {
    type: UNBLOCK_TENANT_API_SUCCESS,
    meta: { email },
  } as const;
}

export function unblockTenantFailed(error: string) {
  return {
    type: UNBLOCK_TENANT_API_FAILED,
    payload: error,
  } as const;
}

export type UserActionTypes = ReturnType<
  | typeof fetchOrganizationUsersRequested
  | typeof fetchOrganizationUsersSuccess
  | typeof fetchOrganizationUsersFailed
  | typeof fetchUserByIdRequested
  | typeof fetchUserByIdSuccess
  | typeof fetchUserByIdFailed
  | typeof resetUserPasswordRequested
  | typeof resetUserPasswordSuccess
  | typeof resetUserPasswordFailed
  | typeof fetchOrganizationUsersByUserIdRequested
  | typeof fetchOrganizationUsersByUserIdSuccess
  | typeof fetchOrganizationUsersByUserIdFailed
  | typeof updateUserByIdRequested
  | typeof updateUserByIdSuccess
  | typeof updateUserByIdFailed
  | typeof setIsEditModalOpen
  | typeof blockTenantRequested
  | typeof blockTenantSuccess
  | typeof blockTenantFailed
  | typeof fetchBlockedTenantRequested
  | typeof fetchBlockedTenantSuccess
  | typeof fetchBlockedTenantFailed
  | typeof unblockTenantRequested
  | typeof unblockTenantSuccess
  | typeof unblockTenantFailed
>;
